import {Component, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, WmsSpinnerComponent, WmsTreeComponent } from '@wms/components';
import { forEach, get, isEmpty } from 'lodash-es';
import { CodeInspectService } from '@wms/bottom-left-menu';
import { Router } from '@angular/router';
import { runtimeEventManager } from '@wm/core';
import { WmsWorkspaceManagerService } from '@wms/workspace';
import {removeResizableClass} from "@wms/core";
import {EventManagerService} from "@wms/app";
import {NotificationService} from "@wms/services";
@Component({
  selector: 'wms-code-inspect',
  standalone: true,
  imports: [
    CommonModule,
    WmsSpinnerComponent,
    WmsTreeComponent
  ],
  templateUrl: './code-inspect.component.html',
  styleUrls: ['./code-inspect.component.less']
})
export class CodeInspectComponent extends BaseComponent implements OnInit, OnDestroy {

  nodeObj: any = [];
  activeObj: any = {};
  ERROR_MESSAGE: string = 'com.wavemaker.no.inspection.results';
  NODE_TYPES: any = {
    'FILE': 'file',
    'ERROR_MESSAGE': 'errormessage'
  };
  totalErrorsObj: any = {
    "errorcount": 0,
    "warningcount": 0
  };
  errorsList: any = {};
  selectedNode: any = {};
  refreshInspectSubscription: any;
  loadLatestErrorsSubscription: any;

  constructor(public codeInspectService: CodeInspectService, private router: Router,private wsManager: WmsWorkspaceManagerService, public override eventManager: EventManagerService, private notificationService: NotificationService) {
    super();
    this.refreshInspectSubscription = this.eventManager.refreshInspectObservable().subscribe(() => this.refreshInspect());
    this.loadLatestErrorsSubscription = this.codeInspectService.loadLatestErrorsAsObservable().subscribe((data: any) => {
      this.errorsList = data;
      this.generateErrors();
    });
  }

  ngOnInit(): void {
    this.load();
  }

  /**generates the error list**/
  generateErrors() {
    this.nodeObj = [];
    forEach(this.errorsList.results, (infoObj: any, index: any) => {
      let filePathObj = infoObj.filePath && infoObj.filePath.split('/'),
        label = filePathObj && filePathObj[filePathObj.length - 1],
        children: any = [],
        nodeObject: any = {};
      infoObj.label = label;
      nodeObject = {
        "id": label,
        "collapsed": false,
        "hasChildren": true,
        "title": label,
        "filePath": infoObj.filePath,
        "type": this.NODE_TYPES.FILE,
        "props": {
          "type": this.NODE_TYPES.FILE,
          "fileName": label,
          "filePath": infoObj.filePath
        }
      };
      this.selectedNode = this.nodeObj.length ? { dataItem: this.nodeObj[0] } : null;
      //by default showing all the errors (nodes of tree are expanded)
      children = this.getChildrenErrorNodes(nodeObject) || children;
      nodeObject.children = children;
      this.nodeObj.push(nodeObject);
    });
    this.activeObj = (this.nodeObj.length && this.activeObj) || {};
    this.totalErrorsObj.errorcount = this.errorsList.errorCount;
    this.totalErrorsObj.warningcount = this.errorsList.warningCount;
    this.codeInspectService.inspectErrorsLoadingFlag = false;
  }

  /*
   * function returns the children nodes for a node in the errors tree.
   * @param node
   * @returns array of child nodes
   */
  getChildrenErrorNodes(node: any) {
    let errorslist = [],
      children: any = [];
    if (node.type === this.NODE_TYPES.FILE) {
      errorslist = this.getErrorsList(node.id, node.filePath);
      forEach(errorslist, (errorObj: any) => {
        children.push({
          "id": errorObj.message,
          "collapsed": true,
          "title": errorObj.message,
          "textClass": this.getErrorClass(errorObj.severity),
          "props": {
            "type": this.NODE_TYPES.ERROR_MESSAGE,
            "message": errorObj.message,
            "line": errorObj.line,
            "column": errorObj.column,
            "fileName": node.id,
            "filePath": node.filePath,
            "suggestion": errorObj.suggestion
          }
        });
      });
    }
    return children;
  }

  /**function returns the error list of the selected file
   * @param filename, name of the file
   * @returns array, errors list for the given file**/
  getErrorsList(filename: any, filePath: any) {
    let children: any = [];
    forEach(this.errorsList.results, (infoObj: any) => {
      if (infoObj.label === filename && infoObj.filePath === filePath) {
        children = infoObj.messages;
        return false;
      }
      return;
    });
    return children;
  }

  getErrorClass(severity: any) {
    let textClass = "";
    switch (severity) {
      case 1:
        textClass = "warning";
        break;
      case 2:
        textClass = "error";
        break;
    }
    return textClass;
  }

  /**function closes the inspect errors list console**/
  closeInspect() {
    this.codeInspectService.isInspectCodeEnabled = false;
    removeResizableClass('wm-studio-content-inspect-errors');
  }

  setActiveErrorObj(selectedObj: any, fileName: any, filePath: any) {
    this.activeObj = {
      'message': selectedObj.message,
      'line': selectedObj.line,
      'column': selectedObj.column,
      'fileName': fileName,
      'filePath': filePath,
      'suggestion': selectedObj.suggestion
    };
  }

  /**
   * function to handle click on error node
   */
  handleErrorNodeClick($event: any) {
    let nodeProps = $event.dataItem.props;
    this.selectedNode = $event;
    if (nodeProps) {
      if (nodeProps.type === this.NODE_TYPES.ERROR_MESSAGE) {
        this.setActiveErrorObj(nodeProps, nodeProps.fileName, nodeProps.filePath);
      }
    }
  }

  /**function to refresh the api and start the poll to get the errors if there are any in the project**/
  refreshInspect() {
    (this.codeInspectService.refreshInspect() as Promise<any>).then((response: any) => {
      this.errorsList = response;
      this.generateErrors();
    });
  }

  /**
   * function checks whether given object/array is empty
   * @param obj, object/array which needs to be checked
   * @returns a boolean value true if object/array is empty else false**/
  isEmptyNode(obj: any) {
    return isEmpty(obj);
  }

  /** function to set the focus on the error line **/
  setfocusToLine() {
    runtimeEventManager.emit('set-cursor-position', { lineNumber: this.activeObj.line || 1, column: this.activeObj.column + 1 });
  }

  /** function to navigate to the file which contains the selected error or warning
   * @param activeObj, object which contains details of the error **/
  navigateTo(activeObj: any) {
    let fileName = activeObj.fileName,
      filePathArray = this.activeObj.filePath.split('/'),
      isAppLevel = filePathArray.length > 2 && (filePathArray[filePathArray.length - 2] === 'webapp'),
      isPageLevel = filePathArray.length > 2 && (filePathArray[filePathArray.length - 3] === 'pages'),
      activePageName = get(this.wsManager.getActiveWS(), 'name'),
      isPrefabLevel = this.activeObj.filePath.includes('src/main/webapp/WEB-INF/prefabs');
    if(isPrefabLevel) {
       this.notificationService.show('info', this.locale['MESSAGE_INFO_TITLE'], this.locale['MESSAGE_PREFAB_FILES_RESTRICT']);
    }
    else if (isAppLevel) {
      if (activePageName === fileName) {
        this.setfocusToLine();
      } else {
        this.navigateToFileWorkspace(fileName, activeObj);
      }
    } else {
      if (activePageName === this.activeObj.fileName) {
        this.setfocusToLine();
      } else {
        /* If the inspection error is in Page Elements(JS.HTML,CSS,JSON) */
        if (isPageLevel) {
          this.openPageWS(this.activeObj.fileName);
        }
        else {
          /* For other types */
          this.navigateToFileWorkspace(fileName, activeObj);
        }
      }
    }
  }

  navigateToFileWorkspace(fileName: any, activeObj: any) {
    let getRelativePath = (fullPath: any) => {
      let srcIndex = fullPath.indexOf("/src"), pidIndex= fullPath.indexOf(this.projectService.getProjectId());
      return srcIndex > -1
        ? fullPath.substring(srcIndex)
        :(pidIndex > -1? fullPath.substring(pidIndex + this.projectService.getProjectId().length) : fullPath);
    },
      selectedFileInfo: any = {
        name: fileName,
        relativePath: getRelativePath(activeObj.filePath),
        path: '../project' + getRelativePath(activeObj.filePath),
        type: this.NODE_TYPES.FILE
      };
    if (this.router.url.startsWith('/files')) {
      runtimeEventManager.emit('loadResource', selectedFileInfo);
    }
    else {
      this.router.navigate(['/files', selectedFileInfo]);
    }
  }

  // pageInfo is the pageName with extension
  openPageWS = (pageInfo: any) => { //eg Main.js,
    let parts = pageInfo.split('.'),
      pageName = parts[0],
      tab: any;

    if (!parts[1]) {
      tab = 'DESIGN';
    } else {
      switch (parts[1]) {
        case 'html':
          tab = 'MARKUP';
          break;
        case 'js':
          tab = 'SCRIPT';
          break;
        case 'css':
          tab = 'STYLE';
          break;
        case 'variables':
          tab = 'VARIABLES';
          break;
      }
    }
    let curPos = { lineNumber: this.activeObj.line || 1, column: this.activeObj.column + 1 };
    if (!this.router.url.startsWith('/page/')) {
      console.log('page code inspect ' + pageName)
      this.router.navigate(['page/' + pageName], { replaceUrl: true });
    }
    setTimeout(() => {
      runtimeEventManager.emit('loadPage', { pageName: pageName, tab: tab, curPos: curPos });
    });
  }

  /**function to check whether errors exists in the project**/
  load(polledstate?: any) {
    (this.codeInspectService.load(polledstate, false) as Promise<any>).then((response: any) => {
      this.errorsList = response;
      this.generateErrors();
    });
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    if(this.refreshInspectSubscription)
      this.refreshInspectSubscription.unsubscribe();
  }

}
